import React, { useRef, useImperativeHandle, useState } from "react";
import classes from './Input.module.css';

const Input = React.forwardRef((props, ref) => {
    const inputRef = useRef();

    const activate = () => {
        inputRef.current.focus();
    };

    const focusToEnd = () => {
        const el = inputRef.current;
        if (el) {
            el.focus();
            const len = el.value.length;
            el.setSelectionRange(len, len);
        }
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    useImperativeHandle(ref, () => {
        return {
            focus: activate,
            focusToEnd, // <- expose this method
            input: inputRef.current // optional: give access to raw input if needed
        };
    });

    // password fields get a show/hide 'eye' toggle
    const isPassword = props.type === 'password';
    const [showPassword, setShowPassword] = useState(false);

    const input = (
        <input
            className={`${classes.input} ${props.propsClassName} ${props.isValid === false ? classes.invalid : ''} ${isPassword ? classes.passwordInput : ''}`}
            placeholder={props.placeholder}
            ref={inputRef}
            type={isPassword && showPassword ? 'text' : (props.type || 'text')}
            id={props.id}
            name={props.name}
            autoComplete={props.autoComplete}
            value={props.value}
            onChange={props.onChange}
            onBlur={props.onBlur}
            onKeyPress={handleKeyPress}
            style={props.style}
            maxLength={props.maxLength}
        />
    );

    if (!isPassword) {
        return input;
    }

    return (
        <div className={classes.passwordWrapper}>
            {input}
            <button
                type="button"
                className={classes.visibilityToggle}
                onClick={() => setShowPassword(prev => !prev)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
                <i className={showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'} />
            </button>
        </div>
    );
});

export default Input;
